import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../components/admin/sidebar/AdminSidebar';

const AdminDashboardLayout = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 p-6">
      {/* Left Sidebar */}
      <div className="lg:col-span-1">
        <AdminSidebar />
      </div>

      {/* Right Content Area */}
      <div className="lg:col-span-3">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminDashboardLayout;
